import makeTable from "./makeTable";

const counterpartyGroup = makeTable({
	allIds: ["title", "notes", "amount"],
	i18tPath: (id) => `tableColumns.customers.counterpartyGroups.${id}`,
});

export default counterpartyGroup;
